import { Typography } from '@mui/material';
import Box from '@mui/material/Box';

import Button from '@/components/Button';
import GenericFilters from '@/components/GenericFilters';
import RangeDatePicker from '@/components/RangeDatePicker/RangeDatePicker';

import { filters, Status } from '../../constants';
import { IFilter } from '../../useEnvioFlex';

type FiltersProps = {
  clearFilters: () => void;
  applyFilters: () => void;
  selectedFilters: IFilter;
  onChange: (filterName: string, value: string | Status | null) => void;
};

const Filters = ({ selectedFilters, onChange, clearFilters, applyFilters }: FiltersProps) => {
  const transformedFilters: Record<string, string | string[]> = {
    startDate: selectedFilters.startDate || '',
    endDate: selectedFilters.endDate || '',
    status: selectedFilters.status || '',
  };

  return (
    <Box mt="1rem">
      <GenericFilters
        filters={filters}
        selectedFilters={transformedFilters}
        handleOnChange={onChange}
        typeCheck="radio"
      />
      <Box mt="2rem">
        <Typography variant="h6" mb="1.5rem" fontWeight={600} fontSize="1rem">
          Fecha de creación del pedido
        </Typography>
        <RangeDatePicker startLabel="Desde" endLabel="Hasta" onChange={onChange} untilToday />
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          gap: '1rem',
          margin: '2.5rem 0 0',
          flexDirection: { xs: 'column', sm: 'row' },
          '& button': {
            width: { xs: '100%', sm: 'auto' },
            minWidth: { sm: '140px' },
          },
        }}
      >
        <Button onClick={clearFilters} variant="outlined">
          Borrar filtros
        </Button>
        <Button variant="contained" onClick={applyFilters}>
          Aplicar filtros
        </Button>
      </Box>
    </Box>
  );
};

export default Filters;
